import { useEffect } from 'react';
import EVENTS from '@/utils/Constants/Events';
import { useSearchContext } from '@/context/search';

// api
import { paginationResults } from '@/api/get/searchMultiResults';

export default () => {
  const [{ query, searchTerm, searchType, hasLoadMore }] = useSearchContext();

  useEffect(() => {
    const apiCall = ({ nextPage, gtmEvent = null } = {}) => {
      if (!nextPage) return;
      paginationResults({
        nextPage,
        searchType,
        hasLoadMore,
        query: query.value || searchTerm,
        sort: query.sort,
        successCB: html => {
          DLG.EVE.emit(EVENTS.SEARCH.RESULTS.APPEND, {
            html,
            searchType,
            gtmEvent,
            lastPage: nextPage,
          });
        },
      });
    };

    DLG.EVE.on(EVENTS.SEARCH.RESULTS.PAGINATION, apiCall);

    return () => {
      DLG.EVE.off(EVENTS.SEARCH.RESULTS.PAGINATION, apiCall);
    };
  }, [searchType, query.value]);
};
